// Utility function to convert a NodeList to an array of Chip HTMLElements
export const nodeListToChipArray = (nodeList: NodeList) =>
  Array.from(nodeList)
    .filter((node): node is HTMLElement => node instanceof HTMLElement)
    .filter((element) => typeof element.dataset.chip_type === "string");
